import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  const scrollToPurchase = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.4
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    show: {
      opacity: 1,
      x: 0,
      transition: {
        type: 'spring',
        stiffness: 100
      }
    }
  };
  return <section className="relative pt-6 pb-2 lg:pt-8 lg:pb-4 overflow-visible px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-87">
      <div className="flex justify-center mb-6 lg:mb-8 flex-col items-center" data-id="element-88">
        <img src="https://cdn.magicpatterns.com/uploads/6V1fDAXu7rVeR9gEB5BN1k/LOGO_DECOEMPRENDE.png" alt="Deco Emprende Logo" className="h-44 sm:h-56 object-contain" data-id="element-89" />
      </div>

      <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-90">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-2xl flex flex-col items-center text-center lg:items-start lg:text-left" data-id="element-91">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl leading-[1.1] mb-6 text-deco-text font-bold" data-id="element-92">
            Aprendé{' '}
            <span className="text-deco-terra font-script text-5xl sm:text-6xl lg:text-7xl font-normal px-2" data-id="element-93">
              Falso Vitral
            </span>{' '}
            desde cero con guía paso a paso + plantillas listas para imprimir
          </h1>

          <p className="text-base sm:text-lg text-deco-taupe font-medium mb-8 max-w-xl" data-id="element-94">
            Creá piezas deco con efecto vitral para decorar, regalar o vender,
            aunque no sepas dibujar ni tengas experiencia.
          </p>

          <motion.div variants={containerVariants} initial="hidden" animate="show" className="flex flex-col gap-3 sm:gap-4 mb-8 w-full max-w-md mx-auto lg:mx-0" data-id="element-95">
            {['Guía práctica para principiantes', 'Plantillas para practicar trazos y rellenos', 'Ideas para crear y vender piezas deco'].map((bullet, i) => <motion.div key={i} variants={itemVariants} className="flex items-center gap-3 sm:gap-4 bg-white/80 backdrop-blur-sm p-3 sm:p-4 rounded-2xl border border-deco-warm shadow-sm" data-id="element-96">
                <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-deco-bg flex items-center justify-center text-deco-terra shrink-0 border border-deco-warm" data-id="element-97">
                  <CheckCircle2 size={20} className="sm:w-5 sm:h-5" data-id="element-98" />
                </div>
                <span className="text-deco-text font-medium text-sm sm:text-base text-left" data-id="element-99">
                  {bullet}
                </span>
              </motion.div>)}
          </motion.div>

          <motion.div whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="w-full sm:w-auto rounded-full flex flex-col items-center lg:items-start" data-id="element-100">
            <Button onClick={scrollToPurchase} className="w-full sm:w-auto text-base sm:text-lg px-8 py-4 sm:px-12 sm:py-5 shadow-lg hover:shadow-xl rounded-full bg-deco-terra text-white font-bold transition-all border-2 border-deco-terra/20" data-id="element-101">
              QUIERO EMPEZAR AHORA
            </Button>
            <div className="flex items-center gap-2 mt-4 text-xs sm:text-sm text-deco-muted font-medium" data-id="element-102">
              <ShieldCheck size={16} data-id="element-103" />
              <span data-id="element-104">Acceso inmediato · Producto digital · Pago seguro</span>
            </div>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative mt-8 lg:mt-0 px-2 sm:px-0" data-id="element-105">
          <div className="absolute -top-6 -right-6 w-24 h-24 bg-deco-warm rounded-full blur-2xl -z-10" data-id="element-106"></div>
          <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-deco-sage/20 rounded-full blur-2xl -z-10" data-id="element-107"></div>

          <div className="absolute -bottom-4 right-4 sm:-right-4 bg-white text-deco-text px-4 py-2 rounded-xl shadow-xl border border-deco-warm font-bold text-sm flex items-center gap-2 transform rotate-3" data-id="element-108">
            <span data-id="element-109">Descargás</span>
            <span className="text-deco-terra" data-id="element-110">•</span>
            <span data-id="element-111">Imprimís</span>
            <span className="text-deco-terra" data-id="element-112">•</span>
            <span data-id="element-113">Creás</span>
          </div>
        </motion.div>
      </div>
    </section>;
}